import styled from 'styled-components';
import {
  color,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing
} from '../../../../theme';

export const Card = styled.a<{ $isFeatured?: boolean }>`
  display: flex;
  flex-direction: row;
  /* max-height: 550px; */
  align-items: center;
  text-decoration: none;
  border-radius: ${radius('lg')};
  background-color: ${color('white')};
  color: ${color('midnight_700')};
  transition: 0.3s ease;
  gap: ${({ $isFeatured }) => ($isFeatured ? spacing('lg') : spacing('md'))};
  padding: ${({ $isFeatured }) =>
    $isFeatured ? spacing('lg') : spacing('md')};
  padding-left: ${({ $isFeatured }) =>
    $isFeatured ? spacing('xs') : spacing('xs2')};

  font-size: ${({ $isFeatured }) =>
    $isFeatured ? fontSize('md') : fontSize('xs')};

  &:hover {
    box-shadow: rgb(255, 255, 255) 0px 0px 0px 8px,
      rgba(38, 26, 25, 0.04) 0px 1.51px 5.3px 12px,
      rgba(38, 26, 25, 0.05) 0px 3.03px 4.54px 12px;
    transition: box-shadow 0.3s ease-in-out;
  }

  @media (max-width: ${screen('md')}) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-left: ${({ $isFeatured }) =>
      $isFeatured ? spacing('lg') : spacing('md')};
  }
`;

export const Thumb = styled.div<{ $isFeatured?: boolean }>`
  width: ${({ $isFeatured }) => ($isFeatured ? '50%' : '36%')};
  aspect-ratio: ${({ $isFeatured }) => ($isFeatured ? 16 / 9 : 16 / 9)};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;

    mask-image: url('/images/common/irregular-box-white.svg');
    mask-size: 100% 100%;
    mask-repeat: no-repeat;
    mask-position: center;

    -webkit-mask-image: url('/images/common/irregular-box-white.svg');
    -webkit-mask-size: 100% 100%;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
  }

  @media (max-width: ${screen('md')}) {
    width: 100%;
    border-radius: ${radius('md')};
  }
`;

export const EmptyThumb = styled.div`
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
    47deg,
    ${color('purple_700')},
    ${color('mint_900')} 70%
  );
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    height: auto;
    max-height: 60%;
  }
`;

export const CardContent = styled.div`
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${spacing('xs')};
  text-align: left;

  @media (max-width: ${screen('sm')}) {
    width: 100%;
    flex: unset;
    align-items: center;
    text-align: center;
  }
`;

export const Date = styled.p`
  display: inline-flex;
  align-items: end;
  gap: ${spacing('xs')};

  font-size: ${fontSize('sm')};
  line-height: 1;
  color: ${color('midnight_500')};
  margin: 0 0 ${spacing('xs')} 0;

  @media (max-width: ${screen('sm')}) {
    text-align: center;
  }
`;

export const Title = styled.h2<{ $isFeatured?: boolean }>`
  font-size: ${({ $isFeatured }) =>
    $isFeatured ? fontSize('xl') : fontSize('lg')};
  font-weight: ${fontWeight('bold')};
  margin: 0;
  color: ${color('emerald_750')};
`;

export const Excerpt = styled.div`
  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;
